import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDutyHolderData, getDutyHolderTypes } from "../../Api/DutyHolderDetailApi";
import { mapDutyHolderDatas, mapDutyHolderTypes } from "../Types/DutyHolderDetails/New/DutyHolderDetailsTypes";

// Fetch duty holder types
export const fetchDutyHolderTypes = createAsyncThunk(
    'fetchDutyHolderTypes',
    async (folderId: number, { rejectWithValue }) => {
        try {
            const response = await getDutyHolderTypes(folderId);
            if (response.status) {
                return mapDutyHolderTypes(response.body);
            } else {
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            return rejectWithValue('Failed to fetch duty holder types');
        }
    }
);

// Fetch duty holder data
export const fetchDutyHolderData = createAsyncThunk(
    'fetchDutyHolderData',
    async (folderId: number, { rejectWithValue }) => {
        try {
            const response = await getDutyHolderData(folderId);
            if (response.status) {
                return mapDutyHolderDatas(response.body);
            } else {
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            return rejectWithValue('Failed to fetch duty holder data');
        }
    }
);